import { Injectable } from '@angular/core';
declare let ga: any;
@Injectable()
export class GoogleAnalyticsService {
  constructor() { }
  public emitEvent(eventCategory: string,
    eventAction: string,
    eventLabel: string = null,
    eventValue: number = null) {
    ga('send', 'event', {
      eventCategory: eventCategory,
      eventLabel: eventLabel,
      eventAction: eventAction,
      eventValue: eventValue
    });
  }
  public capturedEvent(documentCategory: string,
    workFlow: string,
    documentType: string,
    documentExtension: string,
    vendorName: string,
    ) {
    ga('send', 'event', {
      documentCategory: documentCategory,
      workFlow:workFlow,
      documentType:documentType,
      documentExtension: documentExtension,
      vendorName:vendorName,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/google_analytics/google-analytics.service.ts